<template>
  <div class="hbp-container hbp-container-above">
    <div class="homepage router-view">
      <div class="post-list">
        <Banner />
      </div>

      <div class="rection-flow">
        <h3 class="homepage__floor-title">响应流程</h3>
        <div class="homepage__floor-tip">我们会有专业的人员对您提交的报告进行评估，跟进并及时反馈最新的处理结果</div>
        <div class="rection-flow-img">
          <img src="../../images/home_flow.png" />
        </div>
      </div>

      <div class="latest-announcement">
        <h3 class="homepage__floor-title">最新公告</h3>
        <div class="homepage__floor-tip">提供最新的活动，请及时查看和关注</div>
        <div class="announcements">
          <ul class="announcement-list-homepage">
            <li class="homepage__card-item--three" v-for="it in latestData" :key="it.title">
                <div class="homepage__card-title--three">{{ it.title }}</div>
                <div class="homepage__card-content--three">{{ it.description }}</div>
                <div class="homepage__card-time--three">{{ it.creationDateStr }}</div>
                <div>
                  <router-link :to="{ path: '/announcement/detail', query: { code: it.announcementId } }">
                    <i class="iconfont icon-youjiantou homepage__card-arrow--right"></i>
                  </router-link>
                </div>
            </li>
          </ul>
        </div>
        <div class="announcement-list-more">
          <router-link class="homepage__floor-button homepage__floor-button" to="announcement"><span>查看更多</span></router-link>
        </div>
      </div>

      <div class="about-me">
        <h3 class="homepage__floor-title">关于我们</h3>
        <div class="homepage__floor-tip">让您快速了解我们的工作以及我们能为您带来的服务</div>
        <div class="about-me-content">
          荣耀一直致力于保护广大用户的安全，荣耀安全应急响应中心(Honor Security Response Center)非常欢迎广大用户向我们反馈荣耀产品和业务的安全漏洞，以帮助我们提升产品和业务的安全性。
        </div>
        <div class="about-me-submit">
          <router-link class="homepage__floor-button homepage__floor-button--near" to="report"><span> 提交漏洞</span></router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeHeader from '../../components/Header.vue';
import Banner from './Banner.vue';

export default {
  name: 'home',
  data() {
    return {
      str: 'Home Page',
      dialogVisible: true,
      latestData: []
    };
  },
  components: { HomeHeader, Banner },
  mounted() {
    this.getAnnouncementList();
  },
  methods: {
    getAnnouncementList: function() {
      let s = new Promise((resolve, reject) => {
        this.$http
          .post('vul/hsrc/vul/report/services/announcement/list', { category: -1 })
          .then(res => {
            if (res.data && res.status === 200) {
              this.latestData = res.data.data.slice(0, 3);
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    }
  }
};
</script>

<style lang="less" scoped>
 @import '../../global/variable';
.homepage {
  .latest-announcement {
    background-color: #f0f0f0;
    margin: 0;
    padding-bottom: 98px;
    text-align: center;
    .announcements {
      .announcement-list-homepage {
       .pageMaxWidth();
        margin: 58px 0 0 0;
        list-style: none;
        display: inline-flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 100%;
      }
    }
    .announcement-list-more {
      .xui-but {
        font-size: 0.8rem !important;
        padding: 0.8rem 1.6rem !important;
        background: none !important;
        border-color: #999;
        a {
          text-decoration: none;
          span {
            color: #333;
            &:hover {
              color: #409eff;
              border-color: #c6e2ff;
              background-color: #ecf5ff;
            }
          }
        }
      }
    }
  }
  .text-white {
    color: white !important;
  }
  .about-me {
     max-width: var(--src--page-size-small);
     padding: 0 20px;
     margin:0 auto;
     text-align: center;
    .about-me-content {
      margin-top: 58px;
      font-size:var(--src--text-size-large-extra2);
      color: var(--src-text-color-primary);
      line-height: 44px;
    }
    .about-me-submit {
      padding-bottom:98px;
    }
  }
}
.rection-flow {
  .pageMaxWidth();
  margin: 0 auto;
  text-align: center;
  .rection-flow-img img {
    margin-top: 58px;
    padding-bottom: 98px;
  }
}
/deep/.xui-carousel__arrow {
  font-size: 2rem !important;
  height: 4rem !important;
  width: 4rem !important;
}
.hbp-containe {
  height: 100%;
  width: 100%;
  min-height: 39rem;
  position: relative;
  .xui-carousel {
    height: 600px;
  }
}
.carousel-item-img {
  width: 100% !important;
}
.xui-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.xui-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.xui-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
body {
  margin: 0;
}

body > .el-container {
  margin-bottom: 40px;
}

.xui-header,
.xui-footer {
  background-color: #b3c0d1;
  color: #333;
  text-align: center;
}
.xui-header {
  position: fixed;
  z-index: 1999;
  width: 100%;
  height: 5rem !important;
  line-height: 5rem;
  padding: 0;
  background-color: #fff;
  opacity: 0.96;
  box-shadow: 0 1px 5px 0px rgb(0 0 0 / 7%), 0 1px 5px 0 rgb(0 0 0 / 7%);
}

.xui-aside {
  background-color: #d3dce6;
  color: #333;
  text-align: center;
  line-height: 200px;
}

.xui-main {
  background-color: #e9eef3;
  color: #333;
  text-align: center;
  line-height: 680px;
  padding: 0;
}

// 20220811改版需求新增的样式
.homepage__floor-title{
  padding-top: 98px;
  font-size: var(--src--text-size-large-extra9);
  color: var(--src-color-primary-dark2s);
  font-weight: var(--src-text-weight-light1);
}

.homepage__floor-tip {
    margin-top: 10px;
    font-size: var( --src--text-size-large-extra1);
    color: var(--src-color-primary-dark3);
    text-align: center;
}

.homepage__card-item--three{
  width: 456px;
  height:247px;
  flex: 1;
  margin: 20px 0 0 24px;
  padding: 40px;
  background-color: var(--src-text-color-white);
  overflow: hidden;
  text-align: left;
  &:first-child {
    margin-left: 0;
  }
}

.homepage__card-title--three {
  font-size: var(--src--text-size-large-extra2);
  color: var(--src-color-primary-dark2);
  white-space: nowrap;
  overflow:hidden;
  text-overflow: ellipsis;
}

.homepage__card-content--three{
  display: -webkit-box;
  -webkit-box-orient:vertical;
  -webkit-line-clamp: 2;
  overflow:hidden;
  height: 42px;
  margin-top: 10px;
  font-size:var(--src--text-size-medium);
  color: var(--src-color-primary-dark3);
}

.homepage__card-time--three{
  margin-top: 30px;
  font-size:var(--src--text-size-default);
  color: var(--src-color-secondary-light3);
}

.homepage__card-arrow--right{
  display:inline-block;
  margin-top:20px;
  font-size:var(--src--text-size-large-extra1);
  color: var(--src-color-primary-dark2);
  transition: all 0.3s;
  &:hover{
    opacity: 0.8;
  }
}

.homepage__floor-button{
  height: 60px;
  line-height: 58px;
  padding:0 55px;
  margin-top: 58px;
  border: 1px solid var(--src-color-secondary-light2);
  border-radius: 3px;
  font-size: var(--src--text-size-large-extra1);
  color: var(--src-color-primary-dark3);
  font-weight: 400;
}

.homepage__floor-button--near{
  margin-top:30px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/Home.vue